module.exports = __webpack_public_path__ + "img/17.2a9edccc.svg";